import MediaBrowser from './MediaBrowser';

export default MediaBrowser;